
import { getPropertyChangeRequestDefaults } from "@/helpers/getPropertyChangeRequestDefaults";
import Vue from "vue";
import ChangeRequestFileUpload from "../AttachmentUploader/ChangeRequestFileUpload.vue";
import {
  propertyChangeRequestMapGetters,
  propertyChangeRequestMapState
} from "@/store/modules/propertychangerequest";
import { mortgageMapActions } from "@/store/modules/mortgage";
import { ITableWrapperColumns } from "@/types";
import { tableColumnsListMortgages } from "./mortgageListView";
import { objectDifference } from "@/helpers";
import { IMortgage } from "@/store/modules/mortgage/types";
import MortgageCompanyPickerModal from "@/components/MortgageCompanyPicker/MortgageCompanyPickerModal.vue";
import { cloneDeep, get, set } from "lodash";
import CustomAlert from "@/components/CustomAlert/CustomAlert.vue";
import { payPlanOptions } from "@/helpers/selectOptions";
interface IData {
  EndorsementsLimitsCheckBox: string;
  activeNames: any[];
  CoverageLimitsRadioButton: string;
  EndorsementsLimitsRadioButton: string;
  MortgageRadioButton: string;
  CoverageLimitsTextAreaLimitNumber: string;
  EndorsementsLimitsTextAreaLimitNumber: string;
  MortgageTextAreaLimitNumber: string;
  consistencyRadioButton: string;
  hasAttachment: boolean;
  message: string;
  tableColumns: ITableWrapperColumns;
  selectedMortgage: IMortgage;
  error: string;
  loading: boolean;
  consistency: boolean;
  activeConsistency: string;
  myAccordionCategory: any[];
  mortgageData: any[];
  mortgageDataAvailable: boolean;
  touchedContent: {
    visible: boolean;
    name: string;
    ref: string;
  };
  hasValidCredentials: boolean;
  mortgageRemarks: string;
  disableMortgageCompanyName: boolean;
  maxCharacterLength: number;
  endorsementDescriptionCharactersLeft: number;
  descriptionCharactersLeft: number;
  propertyChangeRequestLimitDescription: string;
  propertyChangeRequestEndorsementDescription: string;
  mortgagePayPlanRadioButton: string;
  mortgagePositionRadioButton: string;
  mortgagePayorRadioButton: string;
}

const mortgageDefault = {
  _id: "",
  mortgageName: "",
  shortName: "",
  address: "",
  city: "",
  state: "",
  zipCode: "",
  AICode: "",
  createdOn: new Date(),
  modifiedOn: new Date(),
  deleted: false
};
export default Vue.extend({
  name: "PropertyChangeRequestActions",
  components: {
    ChangeRequestFileUpload,
    MortgageCompanyPickerModal,
    CustomAlert
  },

  data(): IData {
    return {
      hasValidCredentials: false,
      EndorsementsLimitsCheckBox: "",
      tableColumns: tableColumnsListMortgages,
      activeNames: [],
      selectedMortgage: mortgageDefault,
      CoverageLimitsRadioButton: "",
      EndorsementsLimitsRadioButton: "",
      MortgageRadioButton: "",
      consistencyRadioButton: "",
      CoverageLimitsTextAreaLimitNumber: "",
      EndorsementsLimitsTextAreaLimitNumber: "",
      MortgageTextAreaLimitNumber: "",
      hasAttachment: false,
      mortgageDataAvailable: false,
      message: "",
      error: "",
      mortgageData: [],
      consistency: false,
      activeConsistency: "0",
      loading: false,
      touchedContent: {
        visible: false,
        name: "",
        ref: ""
      },
      myAccordionCategory: [
        {
          visible: false,
          name: "Coverage/Limits",
          ref: "coverage"
        },
        {
          visible: false,
          name: "Endorsements",
          ref: "endorsement"
        },
        {
          visible: false,
          name: "Mortgage Change",
          ref: "mortgage"
        },
        {
          visible: false,
          name: "Document Upload",
          ref: "document"
        }
      ],
      mortgageRemarks: "",
      disableMortgageCompanyName: false,
      maxCharacterLength: 395,
      endorsementDescriptionCharactersLeft: 395,
      descriptionCharactersLeft: 395,
      propertyChangeRequestLimitDescription: "",
      propertyChangeRequestEndorsementDescription: "",
      mortgagePayPlanRadioButton: "",
      mortgagePayorRadioButton: "",
      mortgagePositionRadioButton: ""
    };
  },
  props: {
    propertyChangeRequestData: {
      type: Object
    },
    changeRequestType: {
      type: String
    },
    isEdit: {
      required: false,
      type: Boolean
    }
  },
  methods: {
    //TODO: refactor this and use validateFields helper function. just needs modification to accommodate array checks being done here
    validateFields(refs: Record<string, any>) {
      let result: any = null;
      if (refs) {
        for (const ref in refs) {
          if (ref && ref.substring(0, 6) === "field_") {
            const element = refs[ref];
            if (Array.isArray(element)) {
              for (const el of element) {
                if (el.$v) {
                  result = el.$v;
                }
              }
            } else if (element.$v) {
              result = element.$v;
            }
          }
        }
      }
      if (result) {
        return result.$error;
      }
      return false;
    },
    updateIsValid() {
      this.hasValidCredentials = this.validateFields(this.$refs);
    },
    ...mortgageMapActions(["getMortgages"]),
    handleMortgageModalSelection(selection: "yes" | "no"): void {
      if (selection === "no") {
        const billInsuredValue = "billInsured";
        this.handleMortgageBillInsuredRadioChange(
          billInsuredValue,
          "data.mortgage.payor"
        );
        this.mortgagePayorRadioButton = billInsuredValue;
      }
      this.$modal.hide("billMortgageModal");
    },
    handleMortgageBillInsuredRadioChange(value: string, fieldKey: string) {
      if (fieldKey === "data.mortgage.mortgagePosition" && value === "only") {
        this.mortgagePayorRadioButton = "";
        this.$emit("updateChangeRequestData", {
          fieldKey: "data.mortgage.payor",
          value: ""
        });
        this.resetMortgagePayPlan();
      }
      if (fieldKey === "data.mortgage.payor" && value === "billMortgage") {
        this.$modal.show("billMortgageModal");
      }

      const isBillInsured = fieldKey.includes("payor");
      const isBillMortgageSelected =
        this.mortgagePayorRadioButton === "billMortgage";
      if (
        isBillInsured &&
        isBillMortgageSelected &&
        this.mortgagePayPlanRadioButton
      ) {
        this.resetMortgagePayPlan();
      }

      this.updateField(fieldKey, value);
    },

    resetMortgagePayPlan() {
      this.mortgagePayPlanRadioButton = "";
      this.$emit("updateChangeRequestData", {
        fieldKey: "data.mortgage.payPlanType",
        value: ""
      });
    },

    updateField(fieldKey: string, value: string) {
      this.$emit("updateChangeRequestData", { fieldKey, value });
    },

    handleOnInputChange() {
      const mortgage: any = get(this.editing?.data, "mortgage", {});
      const result = !!(
        mortgage.address.length &&
        mortgage.mortgage.length &&
        mortgage.mortgageAddress.city.length &&
        mortgage.mortgageAddress.state.length &&
        mortgage.mortgageAddress.zipCode.length
      );
      this.$emit("disableMortgageSubmitButton", !result);
    },
    async scrubMortgageData(dataReceived: any): Promise<any> {
      this.selectedMortgage = dataReceived;
      if (this.enableMortgageFieldWhenOther) {
        (this.$refs.field_mortgage as any)[0].focusFieldRef();
      }
      this.setMortgageData(dataReceived);
      this.$modal.hide("selectMortgageModal");
    },
    handleMortgageRadioChange(value: any) {
      this.$emit("updateChangeRequestData", {
        fieldKey: "data.actions.mortgageAction",
        value: value
      });
      this.disableMortgageCompanyName = false;
      this.$modal.show("selectMortgageModal");
    },

    handleAttachmentDelete(files: Record<string, any>[]) {
      this.$emit("handleAttachmentDelete", files);
    },
    attachmentUploadHandler(data: any) {
      this.$emit("attachmentData", data);
    },
    handleChangeCheckBox($event: any, data: any) {
      if (data.ref === "mortgage") {
        this.disableMortgageCompanyName = true;
        this.$emit("disableMortgageSubmitButton", $event);
      }
      this.touchedContent = data;
      if (!data.visible) {
        return (data.visible = true);
      }
      this.$modal.show("removeDataModal");
    },
    closeModal(): any {
      return this.$modal.hide("removeDataModal");
    },
    setMortgageData(mortgageData: any) {
      const insuredKeys = [
        "data.mortgage.mortgage",
        "data.mortgage.AICode",
        "data.mortgage.mortgageAddress.state",
        "data.mortgage.mortgageAddress.city",
        "data.mortgage.mortgageAddress.zipCode",
        "data.mortgage.address",
        "data.actions.mortgageAction",
        "data.mortgage.payPlanType",
        "data.mortgage.payor",
        "data.mortgage.mortgagePosition"
      ];
      const {
        address,
        city,
        mortgageName,
        state,
        zipCode,
        AICode
      } = mortgageData;

      const dataObject = {
        data: {
          mortgage: {
            AICode,
            mortgage: mortgageName,
            mortgageAddress: {
              state,
              city,
              zipCode
            },
            address
          },
          actions: {
            mortgageAction: this.MortgageRadioButton
          }
        }
      };
      this.resetMortgageFields();
      for (let i = 0; i < insuredKeys.length; i++) {
        this.$emit("updateChangeRequestData", {
          fieldKey: `${insuredKeys[i]}`,
          value:
            get({ ...dataObject, ...mortgageData }, `${insuredKeys[i]}`, "") ||
            ""
        });
      }
    },
    resetMortgageFields() {
      this.mortgagePayorRadioButton = "";
      this.mortgagePositionRadioButton = "";
      this.mortgagePayPlanRadioButton = "";
    },
    clearSelectedMortgage() {
      this.MortgageRadioButton = "";
      const selectedMortgageKeys = [
        "mortgageName",
        "city",
        "state",
        "address",
        "zipCode"
      ];
      const clonedSelectedData = cloneDeep(this.selectedMortgage);
      for (const key of selectedMortgageKeys) {
        set(clonedSelectedData, key, "");
      }

      this.selectedMortgage = clonedSelectedData;
      this.resetMortgageFields();
      this.setMortgageData([]);
    },
    confirmModal(): any {
      this.touchedContent.visible = !this.touchedContent.visible;
      this.$modal.hide("removeDataModal");
      // resetting accordion contents
      // resetting c  overage contents
      if (this.touchedContent.ref == "coverage") {
        this.CoverageLimitsRadioButton = "";
        this.CoverageLimitsTextAreaLimitNumber = "";
        this.$emit("updateChangeRequestData", {
          fieldKey: "data.actions.limitAction",
          value: ""
        });
        this.$emit("updateChangeRequestData", {
          fieldKey: "data.description.limitDescription",
          value: ""
        });
      }
      // resetting endorsement contents
      if (this.touchedContent.ref == "endorsement") {
        this.EndorsementsLimitsRadioButton = "";
        this.EndorsementsLimitsTextAreaLimitNumber = "";
        this.$emit("updateChangeRequestData", {
          fieldKey: "data.description.endorsementDescription",
          value: ""
        });

        this.$emit("updateChangeRequestData", {
          fieldKey: "data.actions.endorsementAction",
          value: ""
        });
      }
      if (this.touchedContent.ref == "mortgage") {
        this.clearSelectedMortgage();
      }
    },
    handleConsistencyChange() {
      if (this.consistency === true) {
        this.$modal.show("removeDataModal");
      }
      this.consistency = !this.consistency;
    },
    handleCharacterCountDown(characters: string) {
      if (characters.length >= this.maxCharacterLength) return 0;
      return this.maxCharacterLength - characters.length;
    },
    handleEndorsementLimitDescription(e: any) {
      this.endorsementDescriptionCharactersLeft = this.handleCharacterCountDown(
        e
      );
    },
    handleLimitDescription(e: any) {
      this.descriptionCharactersLeft = this.handleCharacterCountDown(e);
    }
  },
  computed: {
    showBillMortgage(): boolean {
      if (this.isMortgageDelete) {
        return this.mortgagePositionRadioButton !== "only";
      }
      return true;
    },
    insuredPayPlanOptions() {
      return payPlanOptions(true);
    },
    isMortgageDelete(): boolean {
      return this?.editing?.data?.actions?.mortgageAction === "delete";
    },
    enableUpload(): boolean {
      return !this.myAccordionCategory.some((acc: any) => acc.visible);
    },
    limitDescription(): string {
      return get(
        this.propertyChangeRequestData.data,
        "description.limitDescription",
        ""
      );
    },
    endorsementDescription(): string {
      return get(
        this.propertyChangeRequestData.data,
        "description.endorsementDescription",
        ""
      );
    },
    ...propertyChangeRequestMapState(["editing", "makingApiRequest"]),
    ...propertyChangeRequestMapGetters(["getEditingPropertyChangeRequest"]),
    updatedFields(): any {
      const edited = this.getEditingPropertyChangeRequest;
      const original = getPropertyChangeRequestDefaults({});
      return edited && original ? objectDifference(edited, original) : {};
    },
    enableMortgageFieldWhenOther(): boolean {
      return !!(
        this.selectedMortgage.mortgageName === "OTHER" &&
        this.selectedMortgage.address === "OTHER" &&
        this.selectedMortgage.city === "OTHER" &&
        this.selectedMortgage.state === "OTHER" &&
        this.selectedMortgage.zipCode === "OTHER"
      );
    }
  },

  watch: {
    updatedFields: {
      handler() {
        this.updateIsValid();
        this.$emit("actionsFieldsValid", this.hasValidCredentials);
      }
    },
    "propertyChangeRequestData.data.mortgage.remarks": {
      handler(val) {
        this.mortgageRemarks = val;
      },
      immediate: true
    }
  },
  mounted() {
    const { data = {}, attachments = [] } = this.propertyChangeRequestData;
    const { description = {}, actions = {}, mortgage = {} } = data;

    this.propertyChangeRequestEndorsementDescription =
      description?.endorsementDescription || "";
    this.propertyChangeRequestLimitDescription =
      description?.limitDescription || "";

    this.MortgageRadioButton = actions?.mortgageAction || "";
    this.EndorsementsLimitsRadioButton = actions?.endorsementAction || "";
    this.CoverageLimitsRadioButton = actions?.limitAction || "";
    this.mortgagePayPlanRadioButton = mortgage?.payPlanType || "";
    this.CoverageLimitsTextAreaLimitNumber = mortgage?.listed || "";
    this.mortgagePayPlanRadioButton = mortgage?.payPlanType || "";
    this.mortgagePositionRadioButton = mortgage?.mortgagePosition || "";
    this.mortgagePayorRadioButton = mortgage?.payor || "";

    this.hasAttachment = attachments?.length > 0;

    this.myAccordionCategory[0].visible = Boolean(
      this.CoverageLimitsRadioButton
    );
    this.myAccordionCategory[1].visible = Boolean(
      this.EndorsementsLimitsRadioButton
    );
    this.myAccordionCategory[2].visible = Boolean(this.MortgageRadioButton);
    this.myAccordionCategory[3].visible = Boolean(this.hasAttachment);
  }
});
